import React from 'react';

// Alert types: wide, widest

export default class extends React.Component {
    static propTypes = {
        type: React.PropTypes.string.isRequired,
        title: React.PropTypes.string.isRequired,
        message: React.PropTypes.any.isRequired,
        btnText: React.PropTypes.any.isRequired,
        clickCallback: React.PropTypes.func.isRequired
    };

    render() {

        const containerCSSClass = 'alert-container ' + this.props.type;

        return (
            <div className="alert-modal">
                <div className={containerCSSClass}>
                    <div className="title">{this.props.title}</div>
                    <div className="message">{this.props.message}</div>
                    <button className="btn btn-yellow" onClick={this.props.clickCallback}>
                        {this.props.btnText}
                    </button>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./js/shared/components/Alert.jsx